/* Picobellonails: knoppen vorige/volgende voor productrails. */
(function () {
  if (window.pbSectionsReady) return;
  window.pbSectionsReady = true;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pb-rail-prev], [data-pb-rail-next]');
    if (!btn) return;
    const id = btn.dataset.pbRailPrev || btn.dataset.pbRailNext;
    const rail = document.getElementById(id);
    if (!rail) return;
    const item = rail.querySelector(':scope > li');
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
    rail.scrollBy({ left: btn.dataset.pbRailPrev ? -step : step, behavior: 'smooth' });
  });
})();
